import { AppMachinesService } from "./appMachinesService"
import { AppSession } from "./appSession"
import { IAppMachine, IAppMachines } from "./types"

/** @internal */
export class AppMachines implements IAppMachines {

    private cache = new Map<string, IAppMachine[]>()

    constructor(
        private readonly svc: AppMachinesService,
        private readonly session: AppSession,
        public readonly connectionId = session.connectionId) {
    }

    getMachines(orgId: string): ng.IPromise<IAppMachine[]> {

        const cached = this.cache.get(orgId)

        if (cached) {
            return this.svc.resolve(cached)
        }

        return this.svc.getMachines(this.connectionId, orgId).then(c => {
            c = c || []
            this.cache.set(orgId, c)
            return c
        })

    }

}
